import { currentOrgSlug } from './org-slug'

const MAX_AGE_MS = 10 * 60 * 1000
const key = () => `mcp-login:${currentOrgSlug()}`

// Tab-local and org-scoped: never save a return URL or borrow another org's tokens.
export function startMcpGoogleLogin(challenge: string): void {
  if (!challenge) return
  sessionStorage.setItem(key(), JSON.stringify({ challenge, createdAt: Date.now() }))
  // Match the backend PKCE cookie's /auth/oauth path, including the callback.
  window.location.href = `/auth/oauth/google/start?org=${encodeURIComponent(currentOrgSlug())}`
}

export function consumeMcpLoginContinuation(): string | undefined {
  const raw = sessionStorage.getItem(key())
  sessionStorage.removeItem(key())
  if (!raw) return
  try {
    const value = JSON.parse(raw)
    const age = Date.now() - value.createdAt
    if (
      typeof value.challenge !== 'string' ||
      !value.challenge ||
      typeof value.createdAt !== 'number' ||
      !Number.isFinite(age) ||
      age < 0 ||
      age > MAX_AGE_MS
    )
      return
    return `/oauth2/login?login_challenge=${encodeURIComponent(value.challenge)}`
  } catch {
    return
  }
}
